import { createContext, useContext, useState, useEffect } from "react";
import { FilterLink } from "./FilterLink";
import { useYear } from "../../context/YearContext";

const FilterContext = createContext();

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilter must be used within a FilterProvider");
  }
  return context;
};

export const FilterProvider = ({ children }) => {
  const { year } = useYear();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCountries = async () => {
      setLoading(true);
      setError(null);
      try {
        const link = new FilterLink();
        await link.request(year);
        setCountries(link.countries);
      } catch (error) {
        console.error("Failed to fetch countries:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchCountries();
  }, [year]);

  const value = {
    countries,
    loading,
    error,
  };

  return (
    <FilterContext.Provider value={value}>
      {children}
    </FilterContext.Provider>
  );
};
